import * as React from "react";
import { PlayersPosting } from "@/components";
import { usePostFlowContext } from "../SharedPostFlowContext";

export function PlayersStep() {
  const { setPlayers, selectedPlayerIds, setSelectedPlayerIds } = usePostFlowContext();

  return (
    <PlayersPosting
      disabled={false}
      selectedPlayers={selectedPlayerIds}
      onChange={setSelectedPlayerIds}
      onPlayersLoaded={setPlayers}
    />
  );
}
